import { navigate, useIntl } from "gatsby-plugin-intl";
import React, { useEffect, useRef, useState } from "react";
import { generate } from "shortid";
import axios from "axios";
import { produce } from "immer";
import {
    Button,
    FormControl, FormControlLabel,
    FormLabel,
    Grid,
    Hidden,
    InputLabel,
    makeStyles, Radio, RadioGroup,
    Select,
    TextField,
    Checkbox
} from "@material-ui/core";
import DatePicker from "react-date-picker";
import 'react-date-picker/dist/DatePicker.css';
import 'react-calendar/dist/Calendar.css';
import Disponibilidad from "../disponibilidad";
import Typography from "@material-ui/core/Typography";
import Pasajeros from "../formularios/naranjo/pasajeros.js";
import SendIcon from "@material-ui/icons/Send";
import CircularProgress from "@material-ui/core/CircularProgress";
import ReCAPTCHA from "react-google-recaptcha";
import ReportProblemIcon from "@material-ui/icons/ReportProblem";
import moment from "moment";
import DisponibilidadCamping from "./naranjo/disponibilidadCamping.js";
import PasajerosCamping from "./naranjo/pasajerosCamping.js";
import { all } from "superagent/lib/request-base.js";
import { feriados } from "../defaults";
import {
    getExceptionsForSector,
    getCampingWindowsForSector,
    isDateDisabled,
    isDateForcedClosed,
    isDateForcedOpen,
    isDateInWindow,
} from "../../utils/excepcionesFechas";

const useStyles = makeStyles((theme) => ({
    textField: {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
    },
    formControl: {
        display: "flex"
    },
    displayLinebreak: {
        whiteSpace: "pre-line"
    },
    section: {
        marginTop: "1rem"
    },
    calendar: {
        border: "none"
    }
}));

const scrollToRef = (ref) => window.scrollTo(0, ref.current.offsetTop)
const recaptchaRef = React.createRef();

/*
Props:
 sector ={sectorACG} : Sector de ACG "Santa Rosa"
 horas = {horasSR} : array con horas de reservación
 inputFields =  {inputsPailas} : array de los fields
 costos = {costosPailas} : array con tarifas de cobro
 pago = "Pago con tarjeta al ingresar al Parque" | "Trasnferencia"
 diasPevios = {0} : Días de antelación necesarios para una reservación
 diaCerrado = {[1]} : Días de la semana que está cerrado 0 Domingo - 6 Sábado | -1 ninguno
 cerrado = ['2022-07-01']: Array con fechas en las que un sector puede estar cerrado
 */

const FormularioNaranjo = (props) => {
    FormularioNaranjo.defaultProps = {
        tipo: "turistas",
        cerrado: [],
        iva: 1
    }
    const intl = useIntl();
    const classes = useStyles();
    const reservationId = generate();
    const estado = props.tipo === "escuela" ? "pendiente" : "activa"
    const [charla, setCharla] = useState("No")


    //Parámetros del sector
    const sectorACG = props.sector;
    const excepciones = getExceptionsForSector(sectorACG);
    const campingWindows = getCampingWindowsForSector(sectorACG);
    const [inputFields, setInputFields] = useState(props.inputFields);
    const newPassenger = props.costos.map((unTipo) => {
        const nacional = (unTipo.currency === "colones") ? "Costa Rica" : "";
        const provincia = (unTipo.currency === "colones") ? "" : "Extranjero";
        return {
            cantidad: 0,
            nombrePax: unTipo.label,
            nacional,
            provincia,
            costo: unTipo.value,
            tarifa: unTipo.name,
            moneda: unTipo.labelCurrency,
            id: unTipo.name,
            subtotal: 0
        }
    })

    let [errorMsg, setErrorMsg] = useState(null)
    let [data, setData] = useState(null);
    const [desglosePagos, setDesglosePagos] = useState([]);
    const [cuposDisponibles, setCuposDisponibles] = useState(0);
    const [cuposDisponiblesCamping, setCuposDisponiblesCamping] = useState(0);
    const [pasajeros, setPasajeros] = useState(newPassenger);
    const [paxCount, setPaxCount] = useState(0);
    const [disabledSubmit, setDisableSumbit] = useState(false);
    const [loading, setLoading] = useState(false);
    const [comprobante, setComprobante] = useState([]);
    const [diaDeCobro, setDiaDeCobro] = useState(1) // para manejar dias gratis
    const [subtotalCamping, setSubTotalCamping] = useState(0);

    const formatDate = (theDate) => {
        const dateTimeFormat = new Intl.DateTimeFormat('en', { year: 'numeric', month: '2-digit', day: '2-digit' });
        const [{ value: month }, , { value: day }, , { value: year }] = dateTimeFormat.formatToParts(theDate);
        return (`${year}-${month}-${day}`)
    }

    const parseLocalDate = (dateStr) => {
        const [year, month, day] = dateStr.split('-').map(Number);
        return new Date(year, month - 1, day);
    }

    // let minDateDate = new Date();
    // let minCampingDateDate = new Date();
    // minDateDate.setDate(minDateDate.getDate() + props.diasPevios);
    // // minCampingDateDate.setDate(minCampingDateDate.getDate() + props.diasPevios + 1);
    // while ((props.diaCerrado.includes(minDateDate.getDay()) && !props.feriados.includes(formatDate(minDateDate))) || props.cerrado.includes(formatDate(minDateDate))) {
    //     minDateDate.setDate(minDateDate.getDate() + 1);
    //     minCampingDateDate.setDate(minCampingDateDate.getDate() + 2);
    // }

    let minDateDate = new Date();
    let minCampingDateDate = new Date();

    minDateDate.setDate(minDateDate.getDate() + props.diasPevios);
    minCampingDateDate.setDate(minDateDate.getDate() + 1); // Camping siempre mínimo 1 día después

    // Ajustar ambos respetando excepciones y días cerrados:
    while (
        isDateDisabled({
            date: minDateDate,
            dateStr: formatDate(minDateDate),
            closedWeekdays: props.diaCerrado,
            feriados: props.feriados,
            cerrado: props.cerrado,
            exceptions: excepciones,
        })
    ) {
        minDateDate.setDate(minDateDate.getDate() + 1);
        minCampingDateDate.setDate(minDateDate.getDate() + 1);
    }

    // Ajuste adicional por si el día actual es excepción:
    const hoy = formatDate(new Date());
    if (isDateForcedOpen(hoy, excepciones)) {
        minDateDate = new Date();
        minCampingDateDate = new Date();
        minCampingDateDate.setDate(minCampingDateDate.getDate() + 1);
    }




    const dateTimeFormat = new Intl.DateTimeFormat('en', { year: 'numeric', month: '2-digit', day: '2-digit' });
    const [{ value: month }, , { value: day }, , { value: year }] = dateTimeFormat.formatToParts(minDateDate);
    const fechaFormated = (`${year}-${month}-${day}`)

    const [fechaR, setFechaR] = useState(fechaFormated);
    const [fechaSalidaR, setFechaSalidaR] = useState(fechaFormated);
    const [fecha, setFecha] = useState(minDateDate);
    const [fechaSalida, setFechaSalida] = useState(minCampingDateDate);
    const [nochesCamping, setNochesCamping] = useState(0);
    const [cantidadTotal, setCantidadTotal] = useState(0);

    const [maxDateCamping, setMaxDateCamping] = useState(new Date())
    const [minDateCamping, setMinDateCamping] = useState(new Date())

    const myRef = useRef(null)
    const executeScroll = () => scrollToRef(myRef)

    const [controlCamping, setControlCamping] = useState(false)

    //Post del FormularioNaranjo al servidor
    useEffect(() => {
        async function sendReservation() {
            if (data !== null) {
                setLoading(true)
                const allData = new FormData();
                if (comprobante !== null) {
                    comprobante.forEach(file => {
                        allData.append(generate(), file);
                    });
                }
                allData.append('data', JSON.stringify(data))
                axios.post(process.env.SERVER_URL + "doReserve.php", allData)
                    .then((response) => {
                        if (response.data === 'Success') {
                            navigate("/gracias/", {
                                state: {
                                    data
                                }
                            })
                            setLoading(false)
                        } else {
                            setErrorMsg(null);
                            let error = []
                            error.push(intl.formatMessage({ id: "error.doReserve" }) + response.data);
                            setLoading(false);
                            setErrorMsg(error);
                            executeScroll()
                        }
                    })
            }
        }
        sendReservation();
    }, [data]); //todo como cambiar a useMemo ?


    //Calculo de costos
    useEffect(() => {
        let isSubscribed = true;

        async function recalcularCosto() {
            if (isSubscribed) {
                let subTDolares = pasajeros.reduce(function calcSTD(accumulator, pax) {
                    return (pax.moneda === '$') ? accumulator +
                        // (pax.costo * pax.cantidad * diaDeCobro) 
                        pax.subtotal
                        : accumulator;
                }, 0)
                const subTNacionalesLocal = pasajeros.reduce(function calcSTN(accumulator, pax) {
                    return (pax.moneda === "₡") ? accumulator +
                        pax.subtotal
                        // (pax.costo * pax.cantidad * diaDeCobro) 
                        : accumulator;
                }, 0)
                if (props.tipo === "escuela") {
                    if (charla !== "No") {
                        subTDolares += 27;
                    }
                }
                const countPasajeros = pasajeros.reduce(function calcSTN(accumulator, pax) {
                    if (isNaN(pax.cantidad)) {
                        return accumulator
                    }
                    return accumulator + parseInt(pax.cantidad);
                }, 0)
                setPaxCount(countPasajeros)

                if (controlCamping) {
                    subTDolares = subTDolares + subtotalCamping;
                }

                const ivaDolares = subTDolares * 0.13 * props.iva;
                const totalDolares = subTDolares + ivaDolares;
                const totalDolaresColonesLocal = totalDolares > 0 ? (totalDolares * tipoDeCambio) : 0;
                const iva = subTNacionalesLocal * 0.13 * props.iva;
                const SubtotalNacionalDisplay = subTNacionalesLocal;
                const totalNacionales = subTNacionalesLocal + iva;
                const totalColones = totalNacionales + totalDolaresColonesLocal
                const tdc = (typeof tipoDeCambio === 'number') ? "(TC:" + tipoDeCambio.toString() + ")" : "";
                const formatColones = { maximumFractionDigits: 2, minimumFractionDigits: 2, style: 'currency', currency: 'CRC' };
                const formatDolares = { maximumFractionDigits: 2, minimumFractionDigits: 2, };
                const desglosePagos = [
                    { label: intl.formatMessage({ id: "subtExtDol" }), value: "$" + subTDolares.toLocaleString('es-CR', formatDolares) },
                    { label: intl.formatMessage({ id: "iva" }), value: "$" + ivaDolares.toLocaleString('es-CR', formatDolares) },
                    { label: intl.formatMessage({ id: "totalExt" }), value: "$" + totalDolares.toLocaleString('es-CR', formatDolares) },
                    { label: intl.formatMessage({ id: "subtExtCol" }) + tdc, value: totalDolaresColonesLocal.toLocaleString('es-CR', formatColones) },
                    { label: "", value: "____________" },
                    { label: intl.formatMessage({ id: "subtNac" }), value: SubtotalNacionalDisplay.toLocaleString('es-CR', formatColones) },
                    { label: intl.formatMessage({ id: "iva" }), value: iva.toLocaleString('es-CR', formatColones) },
                    { label: intl.formatMessage({ id: "totalNac" }), value: totalNacionales.toLocaleString('es-CR', formatColones) },
                    { label: "", value: "____________" },
                    { label: intl.formatMessage({ id: "total" }), value: totalColones.toLocaleString('es-CR', formatColones) },
                ];
                await setDesglosePagos(desglosePagos);
            }
        }

        recalcularCosto()
        return () => (isSubscribed = false);
    }, [pasajeros, charla, diaDeCobro, controlCamping, subtotalCamping]) //todo como cambiar a useMemo para pasajeros??


    const [tipoDeCambio, setTipoDeCambio] = useState(null);

    useEffect(() => {
        let isMounted = true;
        const fetchTipoDeCambio = async () => {
            try {
                const response = await axios.get('https://reservaciones.acguanacaste.ac.cr/getTC.php');
                if (!isMounted) return;
                setTipoDeCambio(response.data);
            } catch (error) {
                console.error("Error obteniendo tipo de cambio:", error);
                if (!isMounted) return;
                setTipoDeCambio(null);
            }
        };

        fetchTipoDeCambio();
        return () => {
            isMounted = false;
        };
    }, []);


    /*
    Desactiva los botones de agregar pasajero y enviar en caso de no haber cupos.
     */
    const handleCuposChanges = (cupo) => {
        setCuposDisponibles(cupo)
        if (cupo === 0) {
            setErrorMsg(null)
        } else if (cupo < 0) {
            setDisableSumbit(true)
            setErrorMsg([intl.formatMessage({ id: "error.masPersonas" })])
        }
        else {
            setDisableSumbit(false)
            setErrorMsg(null)
        }
    }
    const handleCuposCampingChanges = (cupo) => {
        setCuposDisponiblesCamping(cupo)
        if (cupo === 0) {
            setErrorMsg(null)
        } else if (cupo < 0) {
            setDisableSumbit(true)
            setErrorMsg([intl.formatMessage({ id: "error.masPersonas" })])
        }
        else {
            setDisableSumbit(false)
            setErrorMsg(null)
        }
    }



    //Validación
    const validateForm = () => {
        let valid = true;
        let errores = [];
        inputFields.forEach(function (field, index) {
            if (field.required && (typeof field.value == "undefined" || field.value.length < 1)) {
                errores.push(intl.formatMessage({ id: field.label }));
                valid = false
            }
        })

        let nan, procedencia, hayExonerados = false;
        pasajeros.forEach(function (pax, index) {
            if (isNaN(pax.cantidad) && !nan) {
                errores.push(intl.formatMessage({ id: "error.nanQty" }));
                valid = false;
                nan = true;
            }
            if (pax.cantidad > 0 && ((pax.nacional === "Costa Rica" && pax.provincia === "") || pax.nacional === "") && !procedencia) {
                errores.push(intl.formatMessage({ id: "error.pais" }))
                valid = false;
                procedencia = true;
            }

            if (pax.id === "exnoeradoPorResolucion" && pax.cantidad > 0) {
                hayExonerados = true;
            }
        })
        if (paxCount < 1) {
            valid = false;
            errores.push(intl.formatMessage({ id: "error.ceroPax" }));
        }
        if (desglosePagos === null) {
            valid = false;
            errores.push(intl.formatMessage({ id: "error.catPago" }));
        }
        if (inputFields[0].value < new Date()) {
            valid = false;
            errores.push(intl.formatMessage({ id: "error.fechaMayor" }))
        }
        if (props.pago === "Transferencia") {
            if (comprobante.length < 1) {
                valid = false;
                errores.push(intl.formatMessage({ id: "error.compDeposito" }))
            }
        }
        if (props.tipo === "escuela") {
            const exonerado = inputFields.filter(field => field.type === "exoneracion")[0]
            if ((exonerado.value === "Si" || hayExonerados) && comprobante.length < 1) {
                valid = false;
                errores.push(intl.formatMessage({ id: "error.compExoneracion" }))
            }
        }
        if (errores.length > 0) {
            errores.unshift(intl.formatMessage({ id: "error.requeridos" }))
            executeScroll()
        }

        setErrorMsg(errores)
        return valid;
    };

    //Alistar los datos para enviarlos.
    const handleSubmit = () => {
        setErrorMsg(null);
        setData(null);
        const validForm = validateForm();
        if (validForm) {
            //console.log("entre")
            if (controlCamping) {
                setData([{
                    sector: encodeURI(sectorACG),
                    reservacion: reservationId,
                    detalles: inputFields,
                    pasajeros: pasajeros,
                    fecha: fechaR,
                    status: estado,
                    pago: props.pago,
                    desglosePagos,
                    tipo: props.tipo,
                    action: "insert",
                    camping: controlCamping,
                    fechaSalida: fechaSalidaR,
                    nochesCamping: nochesCamping,
                    paxCamping: subtotalCamping
                }]);
            }
            else {
                setData([{
                    sector: encodeURI(sectorACG),
                    reservacion: reservationId,
                    detalles: inputFields,
                    pasajeros: pasajeros,
                    fecha: fechaR,
                    status: estado,
                    pago: props.pago,
                    desglosePagos,
                    tipo: props.tipo,
                    action: "insert",
                }]);
            }

        }
    }


    const setTheDate = (theDate) => {
        setFecha(theDate)
        const fechaFormated = formatDate(theDate);
        setFechaR(fechaFormated)
        setInputFields(currentInputFields =>
            produce(currentInputFields, v => {
                v[0].value = fechaFormated;
            }))
        const [{ value: month }, , { value: day }] = dateTimeFormat.formatToParts(theDate);
        const diaGratis = (month == 8 && day == 24) ? 0 : 1; //24 de agosto día de parques es gratis la entrada
        setDiaDeCobro(diaGratis)
        let diaSiguiente = new Date()
        diaSiguiente.setDate(theDate + 1);
        //setTheDateCamping(theDate.setDate(theDate.getDate + 1));
    }
    const setTheDateCamping = (theDate) => {
        console.log(theDate);
        setFechaSalida(theDate)
        const fechaFormated = formatDate(theDate);
        setFechaSalidaR(fechaFormated)
        /*setInputFields(currentInputFields =>
            produce(currentInputFields, v => {
                v[0].value = fechaFormated;
            }))*/
        //@todo: Va a tener que considerar en el cálculo del camping esto.
        const [{ value: month }, , { value: day }] = dateTimeFormat.formatToParts(theDate);
        const diaGratis = (month == 8 && day == 24) ? 0 : 1; //24 de agosto día de parques es gratis la entrada
        setDiaDeCobro(diaGratis)

    }

    const calcularNochesCamping = () => {
        let fecha1 = moment(fecha).startOf('day');
        let fecha2 = moment(fechaSalida).startOf('day');
        let noches = 0;
        noches = fecha2.diff(fecha1, 'days')
        setNochesCamping(noches);
    }

    useEffect(() => {
        calcularNochesCamping()
    }, [nochesCamping, fechaSalida])


    //CALCULA LA FECHA DE ENTRADA PARA OBTENER EL DIA MAXIMO Y ACTUALIZAR PARA FECHA SALIDA
    useEffect(() => {
        if (fecha !== null) {
            const fechaStr = formatDate(fecha); // YYYY-MM-DD
            const diaSemana = fecha.getDay();
            const getMatchingRangeEnd = (window) => {
                const ranges = window?.ranges || [];
                const match = ranges.find(
                    (range) => fechaStr >= range.start && fechaStr <= range.end
                );
                return match ? match.end : null;
            };

            const inicioHabilitado = new Date("2025-04-10"); // jueves anterior a Semana Santa
            const finSemanaSanta = new Date("2025-04-20");   // domingo de resurrección
            const lunesPostSemanaSanta = new Date("2025-04-21");

            // Si está en el rango especial de Semana Santa
            if (fecha >= inicioHabilitado && fecha <= finSemanaSanta) {
                const minDateCamp = new Date(fecha);
                minDateCamp.setDate(fecha.getDate() + 1);

                setMaxDateCamping(lunesPostSemanaSanta);
                setMinDateCamping(minDateCamp);
                setFechaSalida(lunesPostSemanaSanta);

                const [{ value: month }, , { value: day }, , { value: year }] = dateTimeFormat.formatToParts(lunesPostSemanaSanta);
                const fechaFormated = (`${year}-${month}-${day}`);
                setFechaSalidaR(fechaFormated);
                return;
            }

            const isCampingEntryBlocked = (dateObj) => {
                const dateStr = formatDate(dateObj);
                const isForcedOpen =
                    isDateForcedOpen(dateStr, excepciones) ||
                    isDateInWindow(dateStr, campingWindows.entryOpen);
                const isForcedClosed =
                    isDateForcedClosed(dateStr, excepciones) ||
                    isDateInWindow(dateStr, campingWindows.entryClosed);

                if (isForcedOpen) return false;
                if (isForcedClosed) return true;

                if ((dateObj.getDay() === 1 || dateObj.getDay() === 2) && !props.feriados.includes(dateStr)) {
                    return true;
                }

                return isDateDisabled({
                    date: dateObj,
                    dateStr,
                    closedWeekdays: props.diaCerrado,
                    feriados: props.feriados,
                    cerrado: props.cerrado,
                    exceptions: excepciones,
                });
            };

            const entryBlocked = isCampingEntryBlocked(fecha);
            const exitOpenRangeEnd =
                getMatchingRangeEnd(campingWindows.exitOpen) ||
                getMatchingRangeEnd(campingWindows.entryOpen);

            // Lógica habitual para días normales fuera de semana santa
            if (controlCamping && !entryBlocked && exitOpenRangeEnd) {
                const minDateCamp = new Date(fecha);
                minDateCamp.setDate(fecha.getDate() + 1);

                const maxDateCamp = parseLocalDate(exitOpenRangeEnd);

                setMinDateCamping(minDateCamp);
                setMaxDateCamping(maxDateCamp);
                setFechaSalida(minDateCamp);

                const [{ value: month }, , { value: day }, , { value: year }] =
                    dateTimeFormat.formatToParts(minDateCamp);
                const fechaFormated = (`${year}-${month}-${day}`);
                setFechaSalidaR(fechaFormated);
            } else if (controlCamping && !entryBlocked) {
                let proximoLunes = new Date(fecha);

                if (diaSemana !== 1) {
                    let diasASumar = (1 - diaSemana + 7) % 7;
                    if (diasASumar === 0) diasASumar = 7;
                    proximoLunes.setDate(proximoLunes.getDate() + diasASumar);
                }
                if (diaSemana === 1) {
                    proximoLunes.setDate(proximoLunes.getDate() + 7);
                }

                while (feriados.includes(formatDate(proximoLunes))) {
                    proximoLunes.setDate(proximoLunes.getDate() + 7);
                }

                const minDateCamp = new Date(fecha);
                minDateCamp.setDate(fecha.getDate() + 1);

                setMaxDateCamping(proximoLunes);
                setMinDateCamping(minDateCamp);
                setFechaSalida(proximoLunes);

                const [{ value: month }, , { value: day }, , { value: year }] = dateTimeFormat.formatToParts(proximoLunes);
                const fechaFormated = (`${year}-${month}-${day}`);
                setFechaSalidaR(fechaFormated);
            } else if (controlCamping && entryBlocked) {
                modificarFechaEntradaParaCamping();
            } else {
                setFechaSalida(null);
            }
        } else {
            setFechaSalida(null);
        }
    }, [fecha]);



    useEffect(() => {
        modificarFechaEntradaParaCamping()
    }, [controlCamping])

    const modificarFechaEntradaParaCamping = () => {
        if (!controlCamping) return;

        const dateStr = formatDate(fecha);
        const isForcedOpen =
            isDateForcedOpen(dateStr, excepciones) ||
            isDateInWindow(dateStr, campingWindows.entryOpen);

        if (isForcedOpen) return;
        if (fecha.getDay() === 1 || fecha.getDay() === 2) {
            const proximoMiercoles = new Date(fecha);
            const diasASumar = fecha.getDay() === 1 ? 2 : 1;
            proximoMiercoles.setDate(fecha.getDate() + diasASumar);
            setFecha(proximoMiercoles);
        }
    }


    const ComponenteFechaSalida = () => {
        return (
            <FormControl className={classes.formControl}>
                <InputLabel htmlFor="fechaSalida" className={" MuiInputLabel-shrink MuiFormLabel-filled"}>{intl.formatMessage({ id: "fechaSalida" })}</InputLabel>
                <DatePicker
                    id={"fechaSalida"}
                    value={fechaSalida}
                    locale={"es-CR"}
                    readOnly
                    //tileDisabled={({date}) => date.getDay() === 1}
                    tileDisabled={({ date }) => {

                        const dateFormated = formatDate(date)

                        const isForcedOpen =
                            isDateForcedOpen(dateFormated, excepciones) ||
                            isDateInWindow(dateFormated, campingWindows.exitOpen);
                        const isForcedClosed =
                            isDateForcedClosed(dateFormated, excepciones) ||
                            isDateInWindow(dateFormated, campingWindows.exitClosed);

                        if (isForcedOpen) {
                            return false;
                        }
                        if (isForcedClosed) {
                            return true;
                        }
                        //const setiembre  = new Date("09/26/2023").getTime()
                        //const naranjoSet =  (sectorACG == "Naranjo") && date > setiembre

                        return isDateDisabled({
                            date,
                            dateStr: dateFormated,
                            closedWeekdays: props.diaCerrado,
                            feriados: props.feriados,
                            cerrado: props.cerrado,
                            exceptions: excepciones,
                        }); ///|| naranjoSet
                    }}
                    className={classes.calendar + " MuiInputBase-root MuiInput-root MuiInput-underline  MuiInputBase-formControl MuiInput-formControl"}
                    onChange={(value) => {
                        setTheDateCamping(value)
                        // calcularNochesCamping(value)
                    }}
                    minDate={minDateCamping}
                    maxDate={maxDateCamping}
                />
            </FormControl>
        )
    }

    // const ComponenteHoraSalida = () => {
    //     return (
    //         <FormControl className={classes.formControl}>
    //             <InputLabel htmlFor="hora">{intl.formatMessage({ id: "horaSalida" })}</InputLabel>
    //             <Select
    //                 label={intl.formatMessage({ id: "horaLl" })}
    //                 native
    //                 className={classes.textField}
    //                 value={inputFields[1].value}
    //                 onChange={(e) => {
    //                     const hora = e.target.value;
    //                     setInputFields(currentInputFields =>
    //                         produce(currentInputFields, v => {
    //                             v[1].value = hora;
    //                         }))
    //                 }}
    //                 inputProps={{
    //                     name: 'hora',
    //                     id: 'hora',

    //                 }}
    //             >
    //                 {props.horas.map((unaHora, index) => {
    //                     return (<option key={index} value={unaHora.value}>{unaHora.label}</option>)
    //                 })}
    //             </Select>
    //         </FormControl>
    //     )
    // }

    return (

        <>

            <Grid container spacing={3} ref={myRef}>
                <Grid item xs={12}>
                    <FormErrors errors={errorMsg} />
                </Grid>
                {(diaDeCobro === 1) ? null : (
                    <Grid item container alignItems="center"
                        style={{ backgroundColor: "rgb(235,253,234)", padding: "1rem" }} xs={12}>
                        <Grid item xs={1}>
                            <ReportProblemIcon style={{ color: "#356732" }} />
                        </Grid>
                        <Grid item xs={11} md={11}>
                            <Typography variant={"body2"} style={{ color: "#356732" }}>
                                {intl.formatMessage({ id: "diaParques" })}
                            </Typography>
                        </Grid>
                    </Grid>
                )}
            </Grid>
            <Grid container spacing={3} alignItems="center">
                <Grid item xs={12} md={4}>
                    <FormLabel component="legend">{intl.formatMessage({ id: "actividad" })}</FormLabel>

                </Grid>
                <Grid item xs={12} md={8}>
                    <RadioGroup row aria-label="actividad" name="sectoresVisita" defaultValue="dia" onChange={(e) => {
                        const actividad = e.target.value;
                        if (actividad === 'camping') {
                            setControlCamping(true);
                            modificarFechaEntradaParaCamping()
                        }
                        else {
                            setControlCamping(false);
                        }
                    }}>
                        {
                            props.campingNaranjo.actividades.map((value, index) => {
                                return (
                                    <FormControlLabel
                                        key={index}
                                        value={value.actividad}
                                        selected={value.default}
                                        control={<Radio />}
                                        label={intl.formatMessage({ id: value.label })} />
                                )
                            })
                        }
                    </RadioGroup>
                </Grid>
            </Grid>
            <Grid container spacing={3}>
                <Grid item xs={6} sm={4} md={4}>

                    <FormControl className={classes.formControl}>
                        <InputLabel htmlFor="fecha" className={" MuiInputLabel-shrink MuiFormLabel-filled"}>{intl.formatMessage({ id: "fechaEntrada" })}</InputLabel>
                        <DatePicker
                            id={"fecha"}
                            value={fecha}
                            locale={"es-CR"}
                            tileDisabled={({ date }) => {
                                const dateFormated = formatDate(date);

                                const isForcedOpen =
                                    isDateForcedOpen(dateFormated, excepciones) ||
                                    isDateInWindow(dateFormated, campingWindows.entryOpen);
                                const isForcedClosed =
                                    isDateForcedClosed(dateFormated, excepciones) ||
                                    isDateInWindow(dateFormated, campingWindows.entryClosed);

                                if (isForcedOpen) {
                                    return false;
                                }
                                if (isForcedClosed) {
                                    return true;
                                }

                                // Verifica si controlCamping está activo y si es lunes
                                if (controlCamping && date.getDay() === 1 && !props.feriados.includes(dateFormated)) {
                                    return true;
                                }

                                // Verifica otros criterios de deshabilitación
                                return isDateDisabled({
                                    date,
                                    dateStr: dateFormated,
                                    closedWeekdays: props.diaCerrado,
                                    feriados: props.feriados,
                                    cerrado: props.cerrado,
                                    exceptions: excepciones,
                                });
                            }}
                            className={classes.calendar + " MuiInputBase-root MuiInput-root MuiInput-underline  MuiInputBase-formControl MuiInput-formControl"}
                            onChange={(value) => {
                                setTheDate(value);
                            }}
                            readOnly
                            minDate={minDateDate}
                        />


                    </FormControl><br></br>

                    {controlCamping && <ComponenteFechaSalida />}

                </Grid>

                <Grid item xs={6} sm={4} md={4}>
                    <FormControl className={classes.formControl}>
                        <InputLabel htmlFor="hora">{intl.formatMessage({ id: "horaLl" })}</InputLabel>
                        <Select
                            label={intl.formatMessage({ id: "horaLl" })}
                            native
                            className={classes.textField}
                            value={inputFields[1].value}
                            onChange={(e) => {
                                const hora = e.target.value;
                                setInputFields(currentInputFields =>
                                    produce(currentInputFields, v => {
                                        v[1].value = hora;
                                    }))
                            }}
                            inputProps={{
                                name: 'hora',
                                id: 'hora',

                            }}
                        >
                            {props.horas.map((unaHora, index) => {
                                return (<option key={index} value={unaHora.value}>{unaHora.label}</option>)
                            })}
                        </Select>
                    </FormControl><br></br>

                    {/* AGREGAR EL LABEL AL INTL */}
                    {
                        (controlCamping) ?
                            <InputLabel>Cantidad de noches reservadas: {nochesCamping}</InputLabel>
                            :
                            <></>
                    }



                    {/* {controlCamping && <ComponenteHoraSalida />} */}
                </Grid>

                {/* <Grid>
                    <FormControlLabel control={<Checkbox onChange={() => {
                        setControlCamping(!controlCamping);
                    }} />} label="Camping" />

                </Grid> */}

                <Grid item sm={3} md={2}>
                    {(controlCamping) ?
                        <DisponibilidadCamping sector={sectorACG}
                            fecha={fechaR}
                            fechaSalida={fechaSalidaR}
                            paxCount={paxCount}
                            cuposDisponibles={cuposDisponiblesCamping}
                            onChange={handleCuposCampingChanges}
                            controlCamping={controlCamping}
                        />
                        :
                        <Disponibilidad sector={sectorACG}
                            fecha={fechaR}
                            paxCount={paxCount}
                            cuposDisponibles={cuposDisponibles}
                            onChange={handleCuposChanges}
                        />
                    }
                    {/* <Disponibilidad sector={sectorACG}
                        fecha={fechaR}
                        paxCount={paxCount}
                        cuposDisponibles={cuposDisponibles}
                        onChange={handleCuposChanges}
                    />
                    <br></br>
                    <DisponibilidadCamping sector={sectorACG}
                        fecha={fechaR}
                        fechaSalida={fechaSalidaR}
                        paxCount={paxCount}
                        cuposDisponibles={cuposDisponiblesCamping}
                        onChange={handleCuposCampingChanges}
                        controlCamping={controlCamping}
                    /> */}
                </Grid>
            </Grid>
            <Detalles
                inputFields={inputFields}
                setInputFields={setInputFields}
                position={"mid"}
                charla={charla}
                setCharla={setCharla}
                setComprobante={setComprobante}
                width={4}

            />

            <Grid container className={classes.section} spacing={3} alignItems="center">
                <Grid item xs={12}>
                    <FormLabel component="legend">{intl.formatMessage({ id: "pasajeros" })}</FormLabel>
                    <Typography variant={"body2"}>{intl.formatMessage({ id: "gruposPax" })}</Typography>

                </Grid>
            </Grid>
            <Pasajeros
                pasajeros={pasajeros}
                setPasajeros={setPasajeros}
                diaDeCobro={diaDeCobro}
                controlCamping={controlCamping}
                nochesCamping={nochesCamping}
                calcularNochesCamping={calcularNochesCamping}
                setCantidadTotal={setCantidadTotal}

            />
            <PasajerosCamping
                controlCamping={controlCamping}
                pasajeros={pasajeros}
                cantidadTotal={cantidadTotal}
                subtotal={subtotalCamping}
                setSubtotal={setSubTotalCamping}
                nochesCamping={nochesCamping}
            />

            <Grid container spacing={3}>
                <Grid item xs={12}>
                    {(props.pago === "Transferencia") ? (
                        <FormLabel component="legend">{intl.formatMessage({ id: "pres" })}</FormLabel>
                    ) : (
                        <Typography variant={"body1"}>{intl.formatMessage({ id: "prespailas" })}</Typography>
                    )}
                </Grid>
                <NumerosDeCuenta
                    pago={props.pago}
                    sector={props.sector}
                />

                <Grid item xs={12} md={6}>
                    {desglosePagos.map((pago, index) => {
                        return (
                            <Grid key={index} item xs={12} container justifyContent={"flex-end"}>
                                <Grid item xs={9}>
                                    <Typography variant={"body1"}>{pago.label}</Typography>
                                </Grid>
                                <Grid item xs={3} style={{ textAlign: "right" }}>
                                    <Typography variant={"body1"}>
                                        <strong> {pago.value}</strong>
                                    </Typography>
                                </Grid>
                            </Grid>
                        )
                    })}
                </Grid>

            </Grid>

            {(props.pago === "Transferencia") && (
                <Grid container spacing={3}>
                    <Grid item xs={12}>
                        <Typography variant={"body2"}>
                            {intl.formatMessage({ id: "numDep" })}
                        </Typography>
                    </Grid>


                    <Grid item xs={6} md={6}>
                        <FormControl className={classes.formControl}>
                            <InputLabel htmlFor={"comprobante"} id="comprobante-label">{intl.formatMessage({ id: "comprob" })}</InputLabel>
                            <input accept="image/*, application/pdf"
                                id="comprobante"
                                type="file"
                                multiple={true}
                                onChange={(e) => {
                                    let files = [];
                                    for (let i = 0; i < e.target.files.length; i++) {
                                        files.push(e.target.files[i]);
                                    }
                                    setComprobante(files)
                                }}
                            />
                        </FormControl>
                    </Grid>
                    <Grid item xs={6}>
                        <Detalles
                            inputFields={inputFields}
                            setInputFields={setInputFields}
                            position={"bottom"}
                            width={6}
                            setCharla={setCharla}
                            setComprobante={setComprobante}
                        />
                    </Grid>
                </Grid>
            )}

            <Grid container spacing={3}>
                <Grid item xs={6} md={6}>
                    <Button
                        variant="contained"
                        color="primary"
                        type={"Submit"}
                        disabled={disabledSubmit}
                        onClick={(e) => {
                            e.preventDefault();
                            handleSubmit()
                        }}
                        startIcon={<SendIcon />}
                    >{intl.formatMessage({ id: "enviar" })}
                    </Button>
                    {loading ? <div><CircularProgress /> {intl.formatMessage({ id: "espere" })}</div> : null}
                </Grid>


            </Grid>
            <ReCAPTCHA
                ref={recaptchaRef}
                size="invisible"
                sitekey="6LdtF6YZAAAAADQ-dNM1T1N7OY7UnQ8VioDwGVP0"
            />

        </>
    )
}

const Detalles = (props) => {
    const intl = useIntl();
    const classes = useStyles();
    Detalles.defaultProps = {
        width: 4,
        charla: "No"
    }
    const [exnorado, setExonerado] = useState("No")
    return (
        <Grid container spacing={3}>
            {props.inputFields.map((item, index) => {
                //console.log(item)
                if (item.position === props.position) {
                    if (item.type === "exoneracion") {
                        return (
                            <Grid item container xs={12} key={index}>
                                <Grid item xs={6} md={props.width} >
                                    <FormLabel component="legend">{intl.formatMessage({ id: "exres" })}</FormLabel>
                                    <RadioGroup row
                                        label={intl.formatMessage({ id: "exres" })}
                                        name={"exonerado"}
                                        value={item.value}
                                        onChange={(e) => {
                                            const value = e.target.value;
                                            props.setInputFields(currentInputFields =>
                                                produce(currentInputFields, v => {
                                                    v[index].value = value;
                                                }))
                                            setExonerado(value)
                                        }}
                                    >
                                        <FormControlLabel
                                            value="Si"
                                            control={<Radio />}
                                            label={intl.formatMessage({ id: "Si" })}
                                            labelPlacement="start"
                                        />
                                        <FormControlLabel
                                            value="No"
                                            control={<Radio />}
                                            label={intl.formatMessage({ id: "No" })}
                                            labelPlacement="start"
                                        />
                                    </RadioGroup>
                                </Grid>
                                <Grid item sm={3}>
                                    <FormControl className={classes.formControl}>
                                        <InputLabel htmlFor={"comprobante"} id="comprobante-label">{intl.formatMessage({ id: "comprob" })}</InputLabel>
                                        <input accept="image/*, application/pdf"
                                            disabled={(exnorado !== "Si")}
                                            id="comprobante"
                                            type="file"
                                            multiple={true}
                                            onChange={(e) => {
                                                let files = [];
                                                for (let i = 0; i < e.target.files.length; i++) {
                                                    files.push(e.target.files[i]);
                                                }
                                                // console.log("files", files);
                                                props.setComprobante(files)
                                            }}
                                        />
                                    </FormControl>
                                </Grid>
                            </Grid>
                        )
                    }
                    if (item.type === "charla") {
                        return (
                            <Grid item container xs={12} key={index}>
                                <Grid item xs={6} md={props.width} >

                                    <FormLabel component="legend">{item.label}</FormLabel>
                                    <RadioGroup row
                                        aria-label={item.label}
                                        name={item.name}
                                        value={props.charla}
                                        onChange={(e) => {
                                            const value = e.target.value;
                                            props.setInputFields(currentInputFields =>
                                                produce(currentInputFields, v => {
                                                    v[index].value = value;
                                                }))
                                            props.setCharla(value)
                                        }}
                                    >
                                        <FormControlLabel
                                            value={"Si"}
                                            control={<Radio />}
                                            label={intl.formatMessage({ id: "Si" })}
                                            labelPlacement="start"
                                        />
                                        <FormControlLabel
                                            value="No"
                                            control={<Radio />}
                                            label={intl.formatMessage({ id: "No" })}
                                            labelPlacement="start"
                                        />
                                    </RadioGroup>

                                </Grid>
                                <Grid item xs={3} md={props.width} key={index}>
                                    <FormLabel component="legend">{intl.formatMessage({ id: "horaCharla" })}</FormLabel>
                                    <RadioGroup row
                                        disabled={(props.charla === "No")}
                                        required={(props.charla === "No")}
                                        label={intl.formatMessage({ id: "horaCharla" })}
                                        name={item.name}
                                        value={item.hora}
                                        onChange={(e) => {
                                            const value = e.target.value;
                                            props.setInputFields(currentInputFields =>
                                                produce(currentInputFields, v => {
                                                    v[index].value = "Si";
                                                    v[index].hora = value
                                                    //console.log(v[index].value)
                                                }))
                                        }}
                                    >

                                        <FormControlLabel
                                            value="9:00 am"
                                            disabled={(props.charla === "No")}
                                            control={<Radio />}
                                            label="9:00 am"
                                            labelPlacement="start"
                                        />
                                        <FormControlLabel
                                            value="1:00 pm"
                                            disabled={(props.charla === "No")}
                                            control={<Radio />}
                                            label="1:00pm"
                                            labelPlacement="start"
                                        />
                                    </RadioGroup>
                                </Grid>
                                <Grid item xs={6} md={12}>
                                    <Typography variant={"body2"}>
                                        Las charlas tienen un costo de $27 y son sujetas a disponibilidad de personal el
                                        día de su visita. En los próximos tres días hábiles se le confirmará la
                                        disponibilidad de charla para su fecha.
                                    </Typography>
                                </Grid>
                            </Grid>
                        )
                    }
                    if (item.type === "email" || item.type === "text") {
                        return (
                            <Grid item xs={6} md={props.width} key={index}>
                                <TextField type={item.type} name={item.name}
                                    label={intl.formatMessage({ id: item.label })} fullWidth
                                    required={item.required}
                                    onChange={(e) => {
                                        const value = e.target.value;
                                        props.setInputFields(currentInputFields =>
                                            produce(currentInputFields, v => {
                                                v[index].value = value;
                                            }))
                                    }}
                                />
                            </Grid>
                        )
                    }
                }
                return (<div key={index}></div>)
            })
            }
        </Grid>
    )

}
const FormErrors = (props) => {
    const errores = props.errors;
    return (
        <>
            {(errores !== null && errores.length > 0) && (
                <Grid container alignItems="center" style={{ backgroundColor: "rgb(253, 236, 234)", padding: "1rem" }}>
                    <Grid item xs={1}>
                        <ReportProblemIcon style={{ color: "#ad1d1d" }} />
                    </Grid>
                    <Grid item xs={11} md={11}>
                        <Typography variant={"body2"} style={{ color: "#ad1d1d" }}>
                            {errores.map((error, index) => {
                                return (
                                    (index > 1 ? ', ' : '') + error
                                )
                            })
                            }
                        </Typography>
                    </Grid>
                </Grid>
            )}
        </>
    );
}

const NumerosDeCuenta = (props) => {
    const intl = useIntl();
    const classes = useStyles();
    if (props.pago === "Transferencia") {
        if (props.sector === "Horizontes") {
            return (
                <>
                    <Grid item xs={12} md={5}>
                        <Typography className={classes.displayLinebreak} variant={"body2"}>
                            {intl.formatMessage({ id: "descDep" })} "Visita al Sector {props.sector}, ACG"
                            <br /><br />
                            {intl.formatMessage({ id: "ctaColFun1" })} <br />
                            {intl.formatMessage({ id: "ctaColFun2" })} <br />
                            {intl.formatMessage({ id: "ctaColFun3" })} <br />
                            {intl.formatMessage({ id: "ctaColFun4" })} <br />
                            {intl.formatMessage({ id: "ctaColFun5" })} Fundación de Parques Nacionales<br />
                            {intl.formatMessage({ id: "ctaColFun6" })} <br /><br />
                            {intl.formatMessage({ id: "ctaDolFun1" })} <br />
                            {intl.formatMessage({ id: "ctaDolFun2" })} <br />
                            {intl.formatMessage({ id: "ctaDolFun3" })} <br />
                            {intl.formatMessage({ id: "ctaDolFun4" })} <br />
                            {intl.formatMessage({ id: "ctaDolFun5" })} Fundación de Parques Nacionales<br />
                            {intl.formatMessage({ id: "ctaDolFun6" })} <br />
                            {intl.formatMessage({ id: "ctaDolFun7" })} <br />
                        </Typography>
                    </Grid>
                    <Grid item md={1} display={{ xs: 'none' }}>
                    </Grid>
                </>
            )
        } else {
            return (
                <>
                    <Grid item xs={12} md={5}>
                        <Typography className={classes.displayLinebreak} variant={"body2"}>
                            {intl.formatMessage({ id: "descDep" })} "Visita al Sector {props.sector}, ACG"
                            <br /><br />
                            {intl.formatMessage({ id: "ctaColSINAC1" })} <br />
                            {intl.formatMessage({ id: "ctaColSINAC2" })} <br />
                            {intl.formatMessage({ id: "ctaColSINAC3" })} <br />
                            {intl.formatMessage({ id: "ctaColSINAC4" })} <br />
                            {intl.formatMessage({ id: "ctaColSINAC5" })}SINAC FONDO DE PARQUES NACIONALES <br />
                            {intl.formatMessage({ id: "ctaColSINAC6" })} <br />
                            <br />
                            {intl.formatMessage({ id: "ctaDolSINAC1" })} <br />
                            {intl.formatMessage({ id: "ctaDolSINAC2" })} <br />
                            {intl.formatMessage({ id: "ctaDolSINAC3" })} <br />
                            {intl.formatMessage({ id: "ctaDolSINAC4" })} <br />
                            {intl.formatMessage({ id: "ctaDolSINAC5" })}SINAC FONDO DE PARQUES NACIONALES <br />
                            {intl.formatMessage({ id: "ctaDolSINAC6" })} <br />
                        </Typography>
                    </Grid>
                    <Grid item md={1} display={{ xs: 'none' }}>
                    </Grid>
                </>
            )
        }
    }
    else {
        return (
            <Hidden mdDown>
                <Grid item md={6}>
                    <br />
                </Grid>
            </Hidden>


        )
    }
}

export default FormularioNaranjo
